module.exports = __webpack_public_path__ + "static/media/LINK.3d948e8d.svg";